import { ProductVm } from './product.vm';

export class GetProductVm extends ProductVm {}
